import { useEffect } from 'react';

/**
 * Custom hook to handle keyboard navigation for a list of rows.
 *
 * @param {Object[]} rows - The list of rows to navigate.
 * @param {Object|null} sidebarRow - The currently selected row.
 * @param {Function} setSidebarRow - Setter to update the selected row.
 */
export default ({ rows, setSidebarRow, sidebarRow }) => {
  useEffect(() => {
    const handleKeyDown = (event) => {
      if (!sidebarRow || !rows || rows.length === 0) return;

      const idx = rows.findIndex((e) => e.id === sidebarRow.id);

      if (event.key === "ArrowDown") {
        const _idx = Math.min(idx + 1, rows.length - 1);
        setSidebarRow(rows[_idx]);
      } else if (event.key === "ArrowUp") {
        const _idx = Math.max(idx - 1, 0);
        setSidebarRow(rows[_idx]);
      } else if (event.key === "Escape") {
        setSidebarRow(null);
      }
    };

    window.addEventListener("keydown", handleKeyDown);
    return () => {
      window.removeEventListener("keydown", handleKeyDown);
    };
  }, [rows, sidebarRow, setSidebarRow]);
};
